export default __webpack_public_path__ + "static/media/create-campaigns-5.5e5555d9.png";